
import React, { useState } from 'react';
import { useIsMobile } from "@/hooks/use-mobile";
import { useAirportLeaderboard } from "@/components/leaderboard/useAirportLeaderboard";
import { LeaderboardToggle } from "@/components/leaderboard/LeaderboardToggle";
import { MobileLeaderboard } from "@/components/leaderboard/MobileLeaderboard";
import { DesktopLeaderboard } from "@/components/leaderboard/DesktopLeaderboard";
import { useTranslation } from "@/hooks/useTranslation";
import { Skeleton } from "@/components/ui/skeleton";
import { motion } from "framer-motion";

export function Leaderboard() {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const { airportStats, isLoading, showWorst, setShowWorst } = useAirportLeaderboard();
  const [isMounted, setIsMounted] = useState(true);

  if (isLoading) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="space-y-4 w-full"
      >
        <div className="flex justify-between items-center mb-2">
          <Skeleton className="h-8 w-24" />
          <Skeleton className="h-8 w-32" />
        </div>
        <Skeleton className="h-64 w-full" />
      </motion.div>
    );
  }

  if (airportStats.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="text-center py-4"
      >
        <h2 className="text-lg font-semibold">{t('no_reviews_yet')}</h2>
        <p className="text-muted-foreground mt-2">{t('be_first')}</p>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="w-full overflow-x-auto"
    >
      <LeaderboardToggle 
        showWorst={showWorst} 
        onToggleChange={setShowWorst} 
      />
      
      {isMobile ? (
        <MobileLeaderboard 
          airportStats={airportStats} 
          showWorst={showWorst} 
        />
      ) : (
        <DesktopLeaderboard 
          airportStats={airportStats} 
          showWorst={showWorst}
          isMobile={isMobile}
        />
      )}
    </motion.div>
  );
}
